/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import {
  Accordion,
  Button,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Table,
  Popover,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import errorHandler from '../../../../support_func/errorHandler';
import unavailable from '../../../../support_func/unavailable';

const SensorTypesManagement = () => {
const { t } = useTranslation();

const token = localStorage.getItem('autoAcceso');

const [isPending, setIsPending] = useState(false);
const [error, setError] = useState(null);

const config = {
    headers: {
        Authorization: `Bearer ${token}`,
    },
};

const [sensorVisualTypes, setSensorVisualTypes] = useState([]);
const [sensorTypes, setSensorTypes] = useState([]);

const [kindSensors, setKindSensors] = useState([]);

const [sensorVisualTypeForm, setSensorVisualTypeForm] = useState({
    id: null,
    code: '',
    name: '',
    active: true,
    tiposensors_count: 0,
});

const emptySensorTypeForm = {
    id: null,
    clase_sensor: '',
    kindsensor_id: '',
    sensor_visual_type_id: '',
    magnitud: '',
    estado_normal: '',
    tension_cambio: '',
    escala_predefinida: '',
    factor_multiplicador: '',
    suma_corrector: '',
    histeresis: '',
    max_analog_value: '',
    min_analog_value: '',
    analog_output_min: '',
    analog_output_max: '',
    input_voltage: '',
};

const [sensorTypeForm, setSensorTypeForm] = useState(
    emptySensorTypeForm
);
  
const [showSensorVisualTypesList, setShowSensorVisualTypesList] = useState(
    () =>
        localStorage.getItem('showSensorVisualTypesList') !== 'false'
);
const [showSensorTypesList, setShowSensorTypesList] = useState(
    () =>
        localStorage.getItem('showSensorTypesList') !== 'false'
);


const sensorVisualTypeFormRef = useRef(null);
const sensorTypeFormRef = useRef(null);

const [scrollToSensorVisualTypeCode, setScrollToSensorVisualTypeCode] = useState(null);
const [scrollToSensorTypeId, setScrollToSensorTypeId] = useState(null);


const resetSensorVisualTypeForm = () => {
    setSensorVisualTypeForm({
      id: null,
      code: '',
      name: '',
      active: true,
      tiposensors_count: 0,
    });
};

const resetSensorTypeForm = () => {
    setSensorTypeForm(emptySensorTypeForm);
};

const handleSensorVisualTypeSubmit = (e) => {
    e.preventDefault();

    if (sensorVisualTypeForm.id !== null) {
        patchSensorVisualType();
    } else {
        createSensorVisualType();
    }
};

const createSensorVisualType = () => {
    const createdCode = sensorVisualTypeForm.code.trim();
    setIsPending(true);

    axios
        .post(
        `${process.env.REACT_APP_API_SRT}/private2/sensorvisualtypepost`,
        {
            code: createdCode,
            name: sensorVisualTypeForm.name.trim(),
            active: sensorVisualTypeForm.active,
        },
        config
        )
        .then((res) => {
        if (!res.data.code) {
            unavailable(true);
        }

        if (res.data.code === '0') {
            setError(
            t('sensorVisualType') +
                ' ' +
                t('created') +
                ' ' +
                t('success')
            );

            setScrollToSensorVisualTypeCode(createdCode);

            if (!showSensorVisualTypesList) {
                setShowSensorVisualTypesList(true);
                localStorage.setItem('showSensorVisualTypesList', 'true');
            }

            resetSensorVisualTypeForm();
            getSensorVisualTypes();
        } else {
            setIsPending(false);
            setError(t('problem'));
        }
        })
        .catch((error) => {
        errorHandler(error, setIsPending, setError);
        });
};

const patchSensorVisualType = () => {
    setIsPending(true);

    axios
        .patch(
        `${process.env.REACT_APP_API_SRT}/private2/sensorvisualtypepatch`,
        {
            idsensorvisualtype: sensorVisualTypeForm.id,
            code: sensorVisualTypeForm.code.trim(),
            name: sensorVisualTypeForm.name.trim(),
            active: sensorVisualTypeForm.active,
        },
        config
        )
        .then((res) => {
        if (!res.data.code) {
            unavailable(true);
        }

        if (res.data.code === '0') {
            setError(
            t('sensorVisualType') +
                ' ' +
                t('updated') +
                ' ' +
                t('success')
            );

            resetSensorVisualTypeForm();
            getSensorVisualTypes();
        } else {
            setIsPending(false);
            setError(t('problem'));
        }
        })
        .catch((error) => {
        errorHandler(error, setIsPending, setError);
        });
};

const delSensorVisualType = (idsensorvisualtype) => {
    setIsPending(true);

    axios
        .delete(
        `${process.env.REACT_APP_API_SRT}/private2/sensorvisualtypedel`,
        {
            headers: {
            Authorization: `Bearer ${token}`,
            },
            data: {
            idsensorvisualtypes: [idsensorvisualtype],
            },
        }
        )
        .then((res) => {
        if (!res.data.code) {
            unavailable(true);
        }

        if (res.data.code === '0') {
            const deleted = res.data.deleted || [];
            const notDeleted = res.data.not_deleted || [];

            if (deleted.length > 0 && notDeleted.length === 0) {
            setError(
                t('sensorVisualType') +
                ' ' +
                t('deleted') +
                ' ' +
                t('success')
            );
            } else if (deleted.length === 0 && notDeleted.length > 0) {
            setError(
                notDeleted[0].reason ||
                t('sensorVisualTypeCouldNotBeDeleted')
            );
            } else {
            setError(t('problem'));
            }

            if (sensorVisualTypeForm.id === idsensorvisualtype) {
            resetSensorVisualTypeForm();
            }

            getSensorVisualTypes();
        } else {
            setIsPending(false);
            setError(t('problem'));
        }
        })
        .catch((error) => {
        errorHandler(error, setIsPending, setError);
        });
};

const editSensorVisualType = (sensorVisualType) => {
    setSensorVisualTypeForm({
        id: sensorVisualType.id,
        code: sensorVisualType.code || '',
        name: sensorVisualType.name || '',
        active: sensorVisualType.active === true,
        tiposensors_count: sensorVisualType.tiposensors_count || 0,
    });

    sensorVisualTypeFormRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
};

const createSensorType = () => {
    setIsPending(true);

    axios
        .post(
            `${process.env.REACT_APP_API_SRT}/private2/tiposensorpost`,
            buildSensorTypePayload(),
            config
        )
        .then((res) => {
            if (!res.data.code) {
                unavailable(true);
            }

            if (res.data.code === '0') {
                setError(
                    t('sensor') +
                    ' ' +
                    t('created') +
                    ' ' +
                    t('success')
                );

                setScrollToSensorTypeId(res.data.idtiposensor);

                if (!showSensorTypesList) {
                    setShowSensorTypesList(true);
                    localStorage.setItem(
                        'showSensorTypesList',
                        'true'
                    );
                }

                resetSensorTypeForm();

                // Tiposensor cambia y también el contador
                // asociado de SensorVisualType.
                getSensorTypes();
                getSensorVisualTypes();
            } else {
                setIsPending(false);
                setError(t('problem'));
            }
        })
        .catch((error) => {
            errorHandler(
                error,
                setIsPending,
                setError
            );
        });
};

const editSensorType = (sensorType) => {
    setSensorTypeForm({
        id: sensorType.id,

        clase_sensor: sensorType.clase_sensor || '',

        kindsensor_id:
            sensorType.kindsensor?.id?.toString() || '',

        sensor_visual_type_id:
            sensorType.sensor_visual_type?.id?.toString() || '',

        magnitud: sensorType.magnitud || '',

        estado_normal:
            sensorType.estado_normal || '',

        tension_cambio:
            sensorType.tension_cambio ?? '',

        escala_predefinida:
            sensorType.escala_predefinida ?? '',

        factor_multiplicador:
            sensorType.factor_multiplicador ?? '',

        suma_corrector:
            sensorType.suma_corrector ?? '',

        histeresis:
            sensorType.histeresis ?? '',

        max_analog_value:
            sensorType.max_analog_value ?? '',

        min_analog_value:
            sensorType.min_analog_value ?? '',

        analog_output_min:
            sensorType.analog_output_min ?? '',

        analog_output_max:
            sensorType.analog_output_max ?? '',

        input_voltage:
            sensorType.input_voltage ?? '',
    });

    sensorTypeFormRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
};

const patchSensorType = () => {
    const updatedSensorTypeId = sensorTypeForm.id;

    setIsPending(true);

    axios
        .patch(
            `${process.env.REACT_APP_API_SRT}/private2/tiposensorpatch`,
            {
                idtiposensor: sensorTypeForm.id,
                ...buildSensorTypePayload(),
            },
            config
        )
        .then((res) => {
            if (!res.data.code) {
                unavailable(true);
            }

            if (res.data.code === '0') {
                setError(
                    t('sensor') +
                    ' ' +
                    t('updated') +
                    ' ' +
                    t('success')
                );

                setScrollToSensorTypeId(updatedSensorTypeId);

                if (!showSensorTypesList) {
                    setShowSensorTypesList(true);
                    localStorage.setItem(
                        'showSensorTypesList',
                        'true'
                    );
                }

                resetSensorTypeForm();
                getSensorTypes();
                getSensorVisualTypes();
            } else {
                setIsPending(false);
                setError(t('problem'));
            }
        })
        .catch((error) => {
            errorHandler(error, setIsPending, setError);
        });
};

const delSensorType = (idtiposensor) => {
    setIsPending(true);

    axios
        .delete(
            `${process.env.REACT_APP_API_SRT}/private2/tiposensordel`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    idtiposensors: [idtiposensor],
                },
            }
        )
        .then((res) => {
            if (!res.data.code) {
                unavailable(true);
            }

            if (res.data.code === '0') {
                const deleted = res.data.deleted || [];
                const notDeleted = res.data.not_deleted || [];

                if (
                    deleted.length > 0 &&
                    notDeleted.length === 0
                ) {
                    setError(
                        t('sensor') +
                        ' ' +
                        t('deleted') +
                        ' ' +
                        t('success')
                    );
                } else if (
                    deleted.length === 0 &&
                    notDeleted.length > 0
                ) {
                    setError(
                        notDeleted[0].reason ||
                        t('sensorTypeCouldNotBeDeleted')
                    );
                } else {
                    setError(t('problem'));
                }

                if (sensorTypeForm.id === idtiposensor) {
                    resetSensorTypeForm();
                }

                getSensorTypes();
                getSensorVisualTypes();
            } else {
                setIsPending(false);
                setError(t('problem'));
            }
        })
        .catch((error) => {
            errorHandler(error, setIsPending, setError);
        });
};

const handleSensorTypeSubmit = (e) => {
    e.preventDefault();

    if (sensorTypeForm.id !== null) {
        patchSensorType();
    } else {
        createSensorType();
    }
};

const buildSensorTypePayload = () => {
    const payload = {
        clase_sensor: sensorTypeForm.clase_sensor.trim(),
        kindsensor_id: sensorTypeForm.kindsensor_id,
        sensor_visual_type_id: sensorTypeForm.sensor_visual_type_id,
        histeresis: sensorTypeForm.histeresis,
    };

    // Digital y seguridad
    if ([0, 4].includes(selectedKindSensorCode)) {
        payload.estado_normal = sensorTypeForm.estado_normal;
        payload.tension_cambio = sensorTypeForm.tension_cambio;
    }

    // Tensión y corriente
    if ([1, 2].includes(selectedKindSensorCode)) {
        payload.magnitud = sensorTypeForm.magnitud.trim();
        payload.escala_predefinida =
            sensorTypeForm.escala_predefinida;

        payload.min_analog_value =
            sensorTypeForm.min_analog_value;

        payload.max_analog_value =
            sensorTypeForm.max_analog_value;

        payload.analog_output_min =
            sensorTypeForm.analog_output_min;

        payload.analog_output_max =
            sensorTypeForm.analog_output_max;

        payload.input_voltage =
            sensorTypeForm.input_voltage;
    }

    // Contador
    if (selectedKindSensorCode === 3) {
        payload.magnitud = sensorTypeForm.magnitud.trim();
        payload.escala_predefinida =
            sensorTypeForm.escala_predefinida;

        // No se muestra en el formulario.
        payload.histeresis = '0.2';
    }

    return payload;
};

const getSensorVisualTypes = () => {
    setIsPending(true);

        axios
            .get(
            `${process.env.REACT_APP_API_SRT}/private2/sensorvisualtypeget`,
            config
            )
            .then((res) => {
            if (!res.data.code) {
                unavailable(true);
            }

            if (res.data.code === '0') {
                setSensorVisualTypes(res.data.sensor_visual_types || []);
            } else {
                setError(t('problem'));
            }

            setIsPending(false);
            })
            .catch((error) => {
            errorHandler(error, setIsPending, setError);
            });
};

const getSensorTypes = () => {
    setIsPending(true);

    axios
        .get(
        `${process.env.REACT_APP_API_SRT}/private2/tiposensorget`,
        config
        )
        .then((res) => {
        if (!res.data.code) {
            unavailable(true);
        }

        if (res.data.code === '0') {
            setSensorTypes(res.data.tiposensors || []);
            setKindSensors(res.data.kindsensors || []);
        } else {
            setError(t('problem'));
        }

        setIsPending(false);
        })
        .catch((error) => {
        errorHandler(error, setIsPending, setError);
        });
};

const toggleSensorVisualTypesList = () => {
    setShowSensorVisualTypesList((currentValue) => {
        const newValue = !currentValue;

        localStorage.setItem(
        'showSensorVisualTypesList',
        newValue.toString()
        );

        return newValue;
    });
};

const toggleSensorTypesList = () => {
    setShowSensorTypesList((currentValue) => {
        const newValue = !currentValue;

        localStorage.setItem(
            'showSensorTypesList',
            newValue.toString()
        );

        return newValue;
    });
};

useEffect(() => {
    getSensorVisualTypes();
    getSensorTypes();
}, []);

useEffect(() => {
    if (error !== null) {
        window.alert(error);
        setError(null);
    }
}, [error]);

useEffect(() => {
    if (!scrollToSensorVisualTypeCode) {
        return;
    }

    const prefix =
        window.innerWidth >= 768
        ? 'sensor-visual-type-desktop'
        : 'sensor-visual-type-mobile';

    const element = document.getElementById(
        `${prefix}-${scrollToSensorVisualTypeCode}`
    );

    if (element) {
        element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        });

        setScrollToSensorVisualTypeCode(null);
    }
    }, [
    sensorVisualTypes,
    scrollToSensorVisualTypeCode,
    showSensorVisualTypesList,
]);

useEffect(() => {
    if (scrollToSensorTypeId === null) {
        return;
    }

    const element = document.getElementById(
        `sensor-type-${scrollToSensorTypeId}`
    );

    if (element) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });

        setScrollToSensorTypeId(null);
    }
}, [
    sensorTypes,
    scrollToSensorTypeId,
    showSensorTypesList,
]);

const selectedKindSensor = kindSensors.find(
    (kindSensor) =>
        kindSensor.id.toString() === sensorTypeForm.kindsensor_id.toString()
);

const selectedKindSensorCode =
    selectedKindSensor !== undefined
        ? Number(selectedKindSensor.code)
        : null;

const isDigitalSensor =
    selectedKindSensorCode === 0 ||
    selectedKindSensorCode === 4;

const isAnalogSensor =
    selectedKindSensorCode === 1 ||
    selectedKindSensorCode === 2;

const isCounterSensor =
    selectedKindSensorCode === 3;

const isSecuritySensor =
    selectedKindSensorCode === 4;

const handleSensorTypeFormChange = (field, value) => {
    setSensorTypeForm((currentForm) => ({
        ...currentForm,
        [field]: value,
    }));
};

const handleKindSensorChange = (e) => {
    const kindsensorId = e.target.value;

    const kindSensor = kindSensors.find(
        (item) => item.id.toString() === kindsensorId
    );

    const kindSensorCode =
        kindSensor !== undefined
        ? Number(kindSensor.code)
        : null;

    setSensorTypeForm((currentForm) => ({
        ...currentForm,

        kindsensor_id: kindsensorId,

        magnitud:
        [1, 2, 3].includes(kindSensorCode)
            ? currentForm.magnitud
            : '',

        estado_normal:
        [0, 4].includes(kindSensorCode)
            ? currentForm.estado_normal
            : '',

        tension_cambio:
        [0, 4].includes(kindSensorCode)
            ? currentForm.tension_cambio || '2'
            : '',

        escala_predefinida:
        [1, 2, 3].includes(kindSensorCode)
            ? currentForm.escala_predefinida
            : '',

        // Actualmente no se gestionan desde el formulario.
        factor_multiplicador: '',
        suma_corrector: '',

        histeresis:
        kindSensorCode === 0
            ? '0'
            : kindSensorCode === 3
            ? '0.2'
            : [1, 2, 4].includes(kindSensorCode)
            ? currentForm.histeresis
            : '',

        max_analog_value:
        [1, 2].includes(kindSensorCode)
            ? currentForm.max_analog_value
            : '',

        min_analog_value:
        [1, 2].includes(kindSensorCode)
            ? currentForm.min_analog_value
            : '',

        analog_output_min:
        [1, 2].includes(kindSensorCode)
            ? currentForm.analog_output_min
            : '',

        analog_output_max:
        [1, 2].includes(kindSensorCode)
            ? currentForm.analog_output_max
            : '',

        input_voltage:
        [1, 2].includes(kindSensorCode)
            ? currentForm.input_voltage
            : '',
    }));
};

    

  return (
    <Container className='text'>

        {isPending && (
            <div className='working_apis'>
                <div className='text-working-apis'>
                {t('comprobando')}...
                </div>
            </div>
        )}
        
        <Accordion defaultActiveKey='0' className='acc' alwaysOpen>

            <Accordion.Item eventKey='0'>
                <Accordion.Header>
                    <Table bordered className='mb-0'>
                        <thead>
                            <tr className='primary text-center'>
                            <th className='lh-sm'>
                                <p className='fw-normal lh-sm my-0'>
                                {t('sensorVisualTypes')}
                                </p>
                            </th>
                            </tr>
                        </thead>
                    </Table>
                </Accordion.Header>

                <Accordion.Body>

                    <Form
                        ref={sensorVisualTypeFormRef}
                        onSubmit={handleSensorVisualTypeSubmit}
                        style={{ scrollMarginTop: '90px' }}
                    >
                        <Row className='px-0'>

                            <Col xs={12} md={3} className='mb-3 mb-md-0'>
                            <strong>
                                {t('code')}
                                <sup className='text-danger'>*</sup>
                            </strong>

                            <Form.Control
                                required
                                type='text'
                                readOnly={
                                    sensorVisualTypeForm.id !== null &&
                                    sensorVisualTypeForm.tiposensors_count > 0
                                }
                                value={sensorVisualTypeForm.code}
                                onChange={(e) =>
                                    setSensorVisualTypeForm({
                                    ...sensorVisualTypeForm,
                                    code: e.target.value,
                                    })
                                }
                            />
                            </Col>

                            <Col xs={12} md={3} className='mb-3 mb-md-0'>
                            <strong>
                                {t('nombre')}
                                <sup className='text-danger'>*</sup>
                            </strong>

                            <Form.Control
                                required
                                type='text'
                                value={sensorVisualTypeForm.name}
                                onChange={(e) =>
                                setSensorVisualTypeForm({
                                    ...sensorVisualTypeForm,
                                    name: e.target.value,
                                })
                                }
                            />
                            </Col>

                            <Col xs={12} md={4} className='mb-3 mb-md-0'>
                            <strong>{t('activado')}</strong>

                            <Form.Check
                                type='checkbox'
                                checked={sensorVisualTypeForm.active}
                                onChange={(e) =>
                                setSensorVisualTypeForm({
                                    ...sensorVisualTypeForm,
                                    active: e.target.checked,
                                })
                                }
                            />
                            </Col>

                            <Col xs={12} md={3} className='d-flex align-items-end gap-2 mt-2 mt-md-0'>
                            <Button type='submit'>
                                {sensorVisualTypeForm.id
                                ? t('save')
                                : t('create')}
                            </Button>

                            {sensorVisualTypeForm.id && (
                                <Button
                                type='button'
                                className='dark'
                                onClick={resetSensorVisualTypeForm}
                                >
                                {t('cancel')}
                                </Button>
                            )}
                            </Col>

                        </Row>
                    </Form>

                    <div className='text-end mt-2'>
                        <small className='text-muted fst-italic'>
                            {t('requiredFields')}
                            <sup className='text-danger'>*</sup>
                        </small>
                    </div>

                    <hr />

                    <div className='d-flex justify-content-end mb-2'>
                        <Button
                            type='button'
                            size='sm'
                            variant='outline-primary'
                            onClick={toggleSensorVisualTypesList}
                        >
                            {showSensorVisualTypesList
                            ? t('hideList')
                            : t('showList')}
                        </Button>
                    </div>

                    {/* Tabla para escritorio y tablet */}
                    {showSensorVisualTypesList && (
                    <>
                    <div className='d-none d-md-block table-responsive'>
                        <Table bordered hover className='mb-0'>
                            <thead>
                                <tr className='table-header text-center'>
                                    <th>{t('code')}</th>
                                    <th>{t('nombre')}</th>
                                    <th>{t('activado')}</th>
                                    <th>{t('associatedSensorTypes')}</th>
                                    <th>{t('actions')}</th>
                                </tr>
                            </thead>

                            <tbody>
                            {sensorVisualTypes.length === 0 ? (
                                <tr>
                                <td colSpan={5} className='text-center text-muted'>
                                    {t('noSensorVisualTypes')}
                                </td>
                                </tr>
                            ) : (
                                sensorVisualTypes.map((sensorVisualType) => (
                                <tr
                                    key={sensorVisualType.id}
                                    id={`sensor-visual-type-desktop-${sensorVisualType.code}`}
                                    style={{ scrollMarginTop: '90px' }}
                                >
                                    <td>{sensorVisualType.code}</td>

                                    <td>{sensorVisualType.name}</td>

                                    <td className='text-center'>
                                    {sensorVisualType.active ? t('yes') : t('no')}
                                    </td>

                                    <td className='text-center'>
                                    {sensorVisualType.tiposensors_count}
                                    </td>

                                    <td className='text-center text-nowrap'>
                                    <Button
                                        size='sm'
                                        onClick={() => editSensorVisualType(sensorVisualType)}
                                        >
                                        {t('edit')}
                                    </Button>

                                    <Button
                                        size='sm'
                                        className='dark ms-2'
                                        disabled={sensorVisualType.tiposensors_count > 0}
                                        onClick={() =>
                                            window.confirm(t('confirmDeleteSensorVisualType'))
                                            ? delSensorVisualType(sensorVisualType.id)
                                            : null
                                        }
                                        >
                                        {t('deleteG')}
                                    </Button>
                                    </td>
                                </tr>
                                ))
                            )}
                            </tbody>
                        </Table>
                    </div>
                    </>
                    )}

                    {/* Tarjetas para móvil */}
                    {showSensorVisualTypesList && (
                    <>
                    <div className='d-md-none'>
                        {sensorVisualTypes.length === 0 ? (
                            <div className='text-center text-muted py-3 border'>
                            {t('noSensorVisualTypes')}
                            </div>
                        ) : (
                            sensorVisualTypes.map((sensorVisualType) => (
                            <div
                                key={sensorVisualType.id}
                                id={`sensor-visual-type-mobile-${sensorVisualType.code}`}
                                className='border rounded p-3 mb-3'
                                style={{ scrollMarginTop: '90px' }}
                            >
                                <Row className='mb-2'>
                                <Col xs={5}>
                                    <strong>{t('code')}</strong>
                                </Col>

                                <Col xs={7}>
                                    {sensorVisualType.code}
                                </Col>
                                </Row>

                                <Row className='mb-2'>
                                <Col xs={5}>
                                    <strong>{t('nombre')}</strong>
                                </Col>

                                <Col xs={7}>
                                    {sensorVisualType.name}
                                </Col>
                                </Row>

                                <Row className='mb-2'>
                                <Col xs={5}>
                                    <strong>{t('activado')}</strong>
                                </Col>

                                <Col xs={7}>
                                    {sensorVisualType.active ? t('yes') : t('no')}
                                </Col>
                                </Row>

                                <Row className='mb-3'>
                                <Col xs={5}>
                                    <strong>{t('associatedSensorTypes')}</strong>
                                </Col>

                                <Col xs={7}>
                                    {sensorVisualType.tiposensors_count}
                                </Col>
                                </Row>

                                <div className='d-flex gap-2'>
                                <Button
                                    size='sm'
                                    onClick={() => editSensorVisualType(sensorVisualType)}
                                    >
                                    {t('edit')}
                                </Button>

                                <Button
                                    size='sm'
                                    className='dark ms-2'
                                    disabled={sensorVisualType.tiposensors_count > 0}
                                    onClick={() =>
                                        window.confirm(t('confirmDeleteSensorVisualType'))
                                        ? delSensorVisualType(sensorVisualType.id)
                                        : null
                                    }
                                    >
                                    {t('deleteG')}
                                </Button>
                                </div>
                            </div>
                            ))
                        )}
                    </div>
                    </>
                    )}
                </Accordion.Body>
            </Accordion.Item>


        <Accordion.Item eventKey='1'>
          <Accordion.Header>
            <Table bordered className='mb-0'>
              <thead>
                <tr className='primary text-center'>
                  <th className='lh-sm'>
                    <p className='fw-normal lh-sm my-0'>
                      {t('sensores')}
                    </p>
                  </th>
                </tr>
              </thead>
            </Table>
          </Accordion.Header>

          <Accordion.Body>            

            <Form
                ref={sensorTypeFormRef}
                onSubmit={handleSensorTypeSubmit}
                style={{ scrollMarginTop: '90px' }}
            >
                <Row className='px-0'>                    

                    {/* Tipo de sensor */}
                    <Col xs={12} md={4} className='mb-3'>
                        <strong>
                            {t('tipoSensor')}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Select
                            required
                            value={sensorTypeForm.kindsensor_id}
                            onChange={handleKindSensorChange}
                        >
                            <option value=''>
                                {t('select')}
                            </option>

                            {kindSensors.map((kindSensor) => (
                                <option
                                    key={kindSensor.id}
                                    value={kindSensor.id}
                                >
                                    {kindSensor.description}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>

                    {/* Clase de sensor */}
                    <Col xs={12} md={4} className='mb-3'>
                        <strong>
                            {t('nombreSensor')}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Control
                            required
                            type='text'
                            value={sensorTypeForm.clase_sensor}
                            onChange={(e) =>
                                handleSensorTypeFormChange(
                                    'clase_sensor',
                                    e.target.value
                                )
                            }
                        />
                    </Col>

                    {/* Tipo visual */}
                    <Col xs={12} md={4} className='mb-3'>
                        <strong>
                            {t('sensorVisualType')}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Select
                            required
                            value={sensorTypeForm.sensor_visual_type_id}
                            onChange={(e) =>
                                handleSensorTypeFormChange(
                                    'sensor_visual_type_id',
                                    e.target.value
                                )
                            }
                        >
                            <option value=''>
                                {t('select')}
                            </option>

                            {sensorVisualTypes
                            .filter(
                                (sensorVisualType) =>
                                sensorVisualType.active ||
                                sensorVisualType.id.toString() ===
                                    sensorTypeForm.sensor_visual_type_id.toString()
                            )
                            .map((sensorVisualType) => (
                                <option
                                    key={sensorVisualType.id}
                                    value={sensorVisualType.id}
                                    >
                                    {sensorVisualType.name}
                                    {!sensorVisualType.active
                                        ? ` (${t('inactive')})`
                                        : ''}
                                </option>
                            ))}
                        </Form.Select>
                    </Col>

                    {/* Magnitud: tensión, corriente y contador */}
                    {(isAnalogSensor || isCounterSensor) && (
                    <Col xs={12} md={3} className='mb-3'>
                        <strong>
                            {t('magnitude')}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Control
                            required
                            type='text'
                            value={sensorTypeForm.magnitud}
                            onChange={(e) =>
                                handleSensorTypeFormChange(
                                'magnitud',
                                e.target.value
                                )
                            }
                        />
                    </Col>
                    )}

                    {/* Estado normal: digital y seguridad */}
                    {isDigitalSensor && (
                    <Col xs={12} md={3} className='mb-3'>
                        <strong>
                            {t('normalState')}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Select
                            required
                            value={sensorTypeForm.estado_normal}
                            onChange={(e) =>
                                handleSensorTypeFormChange(
                                'estado_normal',
                                e.target.value
                                )
                            }
                        >
                            <option value=''>
                                {t('select')}
                            </option>

                            <option value='abierto'>
                                {t('open')}
                            </option>

                            <option value='cerrado'>
                                {t('closed')}
                            </option>
                        </Form.Select>
                    </Col>
                    )}

                    {/* Tensión de cambio: digital y seguridad */}
                    {isDigitalSensor && (
                    <Col xs={12} md={3} className='mb-3'>
                        <strong>
                            {t('switchingVoltage')}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Control
                            required
                            type='number'
                            step='any'
                            value={sensorTypeForm.tension_cambio}
                            onChange={(e) =>
                                handleSensorTypeFormChange(
                                'tension_cambio',
                                e.target.value
                                )
                            }
                        />
                    </Col>
                    )}

                    {/* Escala: tensión, corriente y contador */}
                    {(isAnalogSensor || isCounterSensor) && (
                    <Col xs={12} md={3} className='mb-3'>
                        <strong>
                            {t('predefinedScale')}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Control
                            required
                            type='number'
                            step='any'
                            value={sensorTypeForm.escala_predefinida}
                            onChange={(e) =>
                                handleSensorTypeFormChange(
                                'escala_predefinida',
                                e.target.value
                                )
                            }
                        />
                    </Col>
                    )}

                    {/* Histéresis: todos */}
                    {selectedKindSensorCode !== null && !isCounterSensor && (
                    <Col xs={12} md={3} className='mb-3'>
                        <strong>
                            {isSecuritySensor ? (
                                <>
                                    {t('alertResetDelay')}
                                    <OverlayTrigger
                                        trigger="click"
                                        placement="bottom"
                                        rootClose
                                        overlay={
                                            <Popover style={{ maxWidth: '300px' }}>
                                                <Popover.Body>
                                                    {t('alertResetDelayHelp')}
                                                </Popover.Body>
                                            </Popover>
                                        }
                                    >
                                        <span
                                            className="ms-1 text-primary"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            ⓘ
                                        </span>
                                    </OverlayTrigger>
                                </>
                            ) : (
                                t('hysteresis')
                            )}
                            <sup className='text-danger'>*</sup>
                        </strong>

                        <Form.Control
                            required
                            type='number'
                            step='any'
                            min='0'
                            readOnly={selectedKindSensorCode === 0}
                            value={sensorTypeForm.histeresis}
                            onChange={(e) =>
                                handleSensorTypeFormChange(
                                'histeresis',
                                e.target.value
                                )
                            }
                        />

                        
                    </Col>
                    )}

                    {/* Campos analógicos */}
                    {isAnalogSensor && (
                    <>
                        <Col xs={12}>
                            <hr />
                        </Col>

                        <Col xs={12} md={3} className='mb-3'>
                            <strong>
                                {t('minimumMeasuredValue')}
                                <sup className='text-danger'>*</sup>
                            </strong>

                            <Form.Control
                                required
                                type='number'
                                step='any'
                                value={sensorTypeForm.min_analog_value}
                                onChange={(e) =>
                                handleSensorTypeFormChange(
                                    'min_analog_value',
                                    e.target.value
                                )
                                }
                            />
                        </Col>

                        <Col xs={12} md={3} className='mb-3'>
                            <strong>
                                {t('maximumMeasuredValue')}
                                <sup className='text-danger'>*</sup>
                            </strong>

                            <Form.Control
                                required
                                type='number'
                                step='any'
                                value={sensorTypeForm.max_analog_value}
                                onChange={(e) =>
                                handleSensorTypeFormChange(
                                    'max_analog_value',
                                    e.target.value
                                )
                                }
                            />
                        </Col>

                        <Col xs={12} md={3} className='mb-3'>
                            <strong>
                                {t('minimumAnalogOutput')}
                                <sup className='text-danger'>*</sup>
                            </strong>

                            <Form.Control
                                required
                                type='number'
                                step='any'
                                value={sensorTypeForm.analog_output_min}
                                onChange={(e) =>
                                handleSensorTypeFormChange(
                                    'analog_output_min',
                                    e.target.value
                                )
                                }
                            />
                        </Col>

                        <Col xs={12} md={3} className='mb-3'>
                            <strong>
                                {t('maximumAnalogOutput')}
                                <sup className='text-danger'>*</sup>
                            </strong>

                            <Form.Control
                                required
                                type='number'
                                step='any'
                                value={sensorTypeForm.analog_output_max}
                                onChange={(e) =>
                                handleSensorTypeFormChange(
                                    'analog_output_max',
                                    e.target.value
                                )
                                }
                            />
                        </Col>

                        <Col xs={12} md={3} className='mb-3'>
                            <strong>
                                {t('inputVoltage')}
                                <sup className='text-danger'>*</sup>
                            </strong>

                            <Form.Control
                                required
                                type='number'
                                step='any'
                                value={sensorTypeForm.input_voltage}
                                onChange={(e) =>
                                handleSensorTypeFormChange(
                                    'input_voltage',
                                    e.target.value
                                )
                                }
                            />
                        </Col>
                    </>
                    )}

                    {/* Botones */}
                    <Col xs={12} className='d-flex gap-2 mt-2'>
                        <Button type='submit'>
                            {sensorTypeForm.id !== null
                            ? t('save')
                            : t('create')}
                        </Button>

                        {sensorTypeForm.id !== null && (
                            <Button
                                type='button'
                                className='dark'
                                onClick={resetSensorTypeForm}
                            >
                                {t('cancel')}
                            </Button>
                        )}
                    </Col>

                </Row>
            </Form>

            <div className='text-end mt-2'>
                <small className='text-muted fst-italic'>
                    {t('requiredFields')}
                    <sup className='text-danger'>*</sup>
                </small>
            </div>

            <hr />

            <div className='d-flex justify-content-end mb-2'>
                <Button
                    type='button'
                    size='sm'
                    variant='outline-primary'
                    onClick={toggleSensorTypesList}
                >
                    {showSensorTypesList
                        ? t('hideList')
                        : t('showList')}
                </Button>
            </div>

            {showSensorTypesList && (

                <div className='table-responsive'>
                    <Table bordered hover className='mb-0'>
                        <thead>
                            <tr className='table-header text-center'>
                                <th>{t('nombreSensor')}</th>
                                <th className='text-nowrap'>{t('tipoSensor')}</th>
                                <th className='text-nowrap'>{t('sensorVisualType')}</th>
                                <th>{t('magnitude')}</th>
                                <th className='text-nowrap'>{t('actions')}</th>
                            </tr>
                        </thead>

                        <tbody>
                        {sensorTypes.length === 0 ? (
                            <tr>
                                <td colSpan={5} className='text-center text-muted'>
                                    {t('noSensorTypes')}
                                </td>
                            </tr>
                        ) : (
                            sensorTypes.map((sensorType) => (
                            <tr key={sensorType.id}
                                id={`sensor-type-${sensorType.id}`}
                                style={{ scrollMarginTop: '90px' }}
                            >
                                <td>{sensorType.clase_sensor}</td>
                                <td className='text-center text-nowrap'>{sensorType.kindsensor?.description}</td>
                                <td className='text-center text-nowrap'>{sensorType.sensor_visual_type?.name || '-'}</td>
                                <td>{sensorType.magnitud}</td>
                                <td className='text-center text-nowrap'>
                                    <Button
                                        size='sm'
                                        onClick={() => editSensorType(sensorType)}
                                    >
                                        {t('edit')}
                                    </Button>

                                    <Button
                                        size='sm'
                                        className='dark ms-2'
                                        onClick={() =>
                                            window.confirm(t('confirmDeleteSensorType'))
                                                ? delSensorType(sensorType.id)
                                                : null
                                        }
                                    >
                                        {t('deleteG')}
                                    </Button>
                                </td>
                            </tr>
                            ))
                        )}
                        </tbody>
                    </Table>
                </div>
            )}
          </Accordion.Body>
        </Accordion.Item>

      </Accordion>
    </Container>
  );
};

export default SensorTypesManagement;